export default __webpack_public_path__ + "static/media/close-popup.e759ebcd.svg";